<div class="flex w-full max-w-[120rem] flex-col space-y-[2.4rem] rounded-[1.6rem] bg-[#192148] pt-[3.2rem] lg:pt-[1.6rem] lg:space-y-[1.6rem] ">
  <div class="flex w-full items-center justify-between px-[3.2rem] lg:flex-col lg:px-[1.6rem] lg:items-center lg:space-y-[1.1rem]">
    <div class="flex items-center space-x-[1.6rem] lg:justify-between lg:w-full">
      <div class="flex space-x-[1rem] lg:space-x-[0.8rem]">
        <i class="icon_new icon_history text-[2.8rem] lg:text-[2.6rem]"></i>
        <span class="text-[2.4rem] font-400 leading-[2.8rem] text-white lg:text-[2rem] leading-[2.4rem]" i18n="@@history.title">История</span>
      </div>
      <a
        [routerLink]="['/payment']"
        class="flex h-[3.2rem] items-center justify-center space-x-[0.6rem] rounded-[0.8rem] bg-dark-400 px-[1rem] !text-light-400 lg:h-[3.2rem] custom-transition-all hover:bg-light-200 hover:!text-white"
      >
        <span class="text-[1.2rem] font-400 leading-[1.6rem]" i18n="@@history.backbutton">Назад</span>
        <i class="icon_new icon_strokeReverse text-[1.6rem]"></i>
    </a>
    </div>
    <div class="flex space-x-[0.6rem] lg:w-full lg:justify-between">
      @for (tab of tabs; track $index) {
        <button
          (click)="currentTab = tab.key"
          [ngClass]="{ '!border-[#5D7EF2] bg-[rgba(93,126,242,0.30)] !text-white': tab.key === currentTab }"
          class="flex h-[4.4rem] items-center justify-center space-x-[0.6rem] overflow-hidden rounded-[1rem] border-[0.2rem] border-solid border-[rgba(93,126,242,0.20)] px-[1.4rem] !text-[#9CB3ED] custom-transition-all hover:border-[rgba(93,126,242,0.40)] hover:bg-[rgba(93,126,242,0.10)] hover:!text-[#CDDBFF] lg:w-full lg:px-[1rem] lg:h-[4.2rem] lg:justify-start"
        >
          <i class="icon_new icon_{{ tab.icon }} text-[2rem] lg:text-[1.8rem]"></i>
          <span class="text-[1.3rem] font-400 leading-[2rem] lg:text-[1.2rem] lg:leading-[1.8rem]">{{ tab.value }}</span>
        </button>
      }
    </div>
  </div>
  @switch (currentTab) {
    @case ('deposits') {
      <deposits-table />
    }

    @case ('withdraws') {
      <withdrawals-table />
    }
  }
</div>
